import React from 'react';
import TableText from "../../../../../hr/components/TableText";
export const columns = [{
    title: '',
    dataIndex: 'name',
    key: 'name',
    align: "center",
    width: 200,
    render: (text, record, index) => {
        const props = { text, index, type: 'text', name: "name" };
        return (
            <TableText data={props} />
        )
    }
}, {
    title: '较去年同期差值',
    dataIndex: 'diff',
    key: 'diff',
    align: "center",
    width: 200,
    render: (text, record, index) => {
        const props = { text, index, type: 'number', name: "diff" };
        return (
            <TableText data={props} />
        )
    }
}, {
    title: '较去年同期比值',
    dataIndex: 'rat',
    key: 'rat',
    align: "center",
    width: 200,
    render: (text, record, index) => {
        const props = { text, index, type: 'percent', name: "rat" };
        return (
            <TableText data={props} />
        )
    }
}];
export const defaultData = [{
    name: "酒店总收入",
    diff: 0,
    rat: 0,
    sort: 0,
}, {
    name: "酒店总人力成本",
    diff: 0,
    rat: 0,
    sort: 1,
}, {
    name: "客房部门收入",
    diff: 0,
    rat: 0,
    sort: 2,
}, {
    name: "客房部门人力成本",
    diff: 0,
    rat: 0,
    sort: 3,
}, {
    name: "客房部门帮工费用",
    diff: 0,
    rat: 0,
    sort: 4,
}, {
    name: "餐饮部门收入",
    diff: 0,
    rat: 0,
    sort: 5,
}, {
    name: "餐饮部门人力成本",
    diff: 0,
    rat: 0,
    sort: 6,
}, {
    name: "餐饮部门帮工费用",
    diff: 0,
    rat: 0,
    sort: 7,
}, {
    name: "其他营业部门收入",
    diff: 0,
    rat: 0,
    sort: 8,
}, {
    name: "其他营业部门人力成本",
    diff: 0,
    rat: 0,
    sort: 9,
}];


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-1TotalPayrollCostAnalysis/7-1-3/data.js